import React, { createContext, useEffect, useState } from "react";
import { init, track } from "@plausible-analytics/tracker";

export const PlausibleContext = createContext();

export const PlausibleProvider = ({ children }) => {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    try {
      // Initialize Plausible tracker with hardcoded configuration
      init({
        domain: "muzio.ioprodz.com",
        endpoint: "https://plausible.ioprodz.com/api/event",
        autoCapturePageviews: true,
        outboundLinks: true,
        captureOnLocalhost: false,
      });

      setInitialized(true);
    } catch (error) {
      console.error("Failed to initialize Plausible Analytics:", error);
    }
  }, []);

  const trackEvent = (eventName, props = {}) => {
    if (!initialized) {
      return;
    }

    try {
      track(eventName, { props });
    } catch (error) {
      console.error("Plausible trackEvent error:", error);
    }
  };

  const trackPageview = (options = {}) => {
    if (!initialized) {
      return;
    }

    try {
      track("pageview", options);
    } catch (error) {
      console.error("Plausible trackPageview error:", error);
    }
  };

  return (
    <PlausibleContext.Provider value={{ trackEvent, trackPageview, initialized }}>
      {children}
    </PlausibleContext.Provider>
  );
};
